import {Provider} from '@angular/core';
import {PRODUCT_FOLDER_REPOSITORY} from '../../domain/tokens/product-folder.token';
import {ProductFolderRepositoryAdapter} from '../adapters/product-folder-repository.adapter';

export const PRODUCT_FOLDER_PROVIDERS: Provider[] = [
  {
    provide: PRODUCT_FOLDER_REPOSITORY,
    useClass: ProductFolderRepositoryAdapter
  },
];
